let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j7gH4")).then(() => parcelRequire('ezgWl'));